import { Component, Inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { AuthService } from '@app/core/services';
import { ApicService } from '@app/core/services/apic.services';
import { ConfigService } from '@app/core/services/config.service';
import { AppState } from '@app/core/store/reducers';
import { Store } from '@ngrx/store';
import { OKTA_AUTH, OktaAuthStateService } from '@okta/okta-angular';
import OktaAuth, { AuthState } from '@okta/okta-auth-js';
import { Observable, filter, map } from 'rxjs';
import { setTrueURLLink } from 'src/main';


@Component({
  templateUrl: './login.component.html'
})
export class LoginComponent {

  public email$!: Observable<string>;
  isAutheticated = false;
  isAuthorized = false;
  isRedirected = false;

  constructor(@Inject(OKTA_AUTH) private oktaAuth: OktaAuth, private oktaAuthStateService: OktaAuthStateService, private configService: ConfigService,
    private store: Store<AppState>, private router: Router, private apicService: ApicService, private authService: AuthService) {
    this.email$ = oktaAuthStateService.authState$.pipe(takeUntilDestroyed(),
      filter((authState: AuthState) => !!authState && !!authState.isAuthenticated),
      map((authState: AuthState) => authState.idToken?.claims.email ?? '')
    );

    this.email$.subscribe((email) => {
      if (email) {
        this.isAutheticated = true;

        apicService.ttoc(oktaAuth.getAccessToken()).then(() => {
          // Handle external links routes to login component
          const pathArray = this.router.url.split('/');
          if (pathArray && pathArray.indexOf('notify') === 1) {
            if (pathArray.indexOf('rid') === 2) {
              this.router.navigate(['/portal/results']).then(() => {
                this.router.navigate(['/portal/results/search-results/' + pathArray[3]]);
              });
            }
            else if (pathArray.indexOf('qid') === 2) {
              this.router.navigate(['/portal/results']).then(() => {
                this.router.navigate(['/portal/results/search/' + pathArray[3]]);
              });
            }
            if (pathArray.indexOf('userpref') === 2) {
              setTrueURLLink();
              this.router.navigate(['/portal/preferences']).then(() => {
                this.router.navigate(['/portal/preferences/user-preferences']);
              });
            }
          }
          this.router.navigate([this.configService.appConfig.application.defaultRoute]);
        });
      } else {
        this.isAutheticated = false;
      }
    });
  }

  public async redirectToOkta(): Promise<void> {
    if (!this.isAutheticated) {
      this.isRedirected = true;
      this.oktaAuth.setOriginalUri(this.router.url);
      await this.oktaAuth.signInWithRedirect();
    }
  }
}
